import { Component, OnInit, Input, Output, SimpleChanges, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, FormArray, Validators, } from '@angular/forms';
import { Observable } from 'rxjs';
import { SignaturePadComponent } from 'src/app/commons/signature-pad/signature-pad.component';
import { MatDialog, MatSnackBar } from '@angular/material';
import { ActivatedRoute } from '@angular/router';
import { MpjobService } from '../../services/jobs/mpjob.service'
import { ChangeDateFormateService } from '../../services/change-date-formate.service';
import * as _ from 'lodash';
import { MedicalFromService } from '../../services/medical-from.service';
import { idConfirmListArray, yesNoArray } from '../../_models/staticArray'
import { MatStepper } from '@angular/material';
import { UserDocumentService } from 'src/app/services/user-document.service';
import * as moment from 'moment';


@Component({
  selector: 'app-consent-form',
  templateUrl: './consent-form.component.html',
  styleUrls: ['./consent-form.component.scss']
})
export class ConsentFormComponent implements OnInit {
  idConfirmList = idConfirmListArray
  yesNo = yesNoArray

  days = [];
  months = [];
  years = [];
  heartDiseaseStatus: boolean = false
  respiratoryDiseaseStatus: boolean = false
  neurologicalDiseaseStatus: boolean = false
  weaknessStatus: boolean = false
  mentalHealthStatus: boolean = false
  musculoskeletalStatus: boolean = false
  sleepDisorderStatus: boolean = false
  endocrineDisorderStatus: boolean = false
  behaviouralDisorderStatus: boolean = false
  visualDisorderStatus: boolean = false
  hearingDisorderStatus: boolean = false
  speechStatus: boolean = false
  bowelDisorderStatus: boolean = false
  kidneyDisorderStatus: boolean = false
  liverDisorderStatus: boolean = false
  allerigiesStatus: boolean = false
  treatmentsStatus: boolean = false
  sleepStatus: boolean = false
  medicationStatus: boolean = false
  testsStatus: boolean = false
  healthAspectStatus: boolean = false
  personalDetailsForm: FormGroup;
  employmentHistoryForm: FormGroup;
  medicalHistoryForm: FormGroup;
  lifestyleForm: FormGroup;
  confirmationForm: FormGroup;
  confirmationSign: any;
  jobId: any;
  consentEdit;
  user;
  allerigies2Status: boolean = false;
  visualDisorder6Status: boolean = false;
  selectedDay;
  selectedMonth;
  selectedYear;

  selectedConfirmDay;
  selectedConfirmMonth;
  selectedConfirmYear;
  otherFormDetails
  @Input('candidateList') candidateList;
  @Input('consentData') consenFormData;
  @Output() consentForm: EventEmitter<any> = new EventEmitter();
  @Output() extraDetails: EventEmitter<any> = new EventEmitter();
  jobTitle: any;
  candidateName: any;
  userId;
  candidateArray;
  candidateDisabled = false;
  showSignErr: any;
  showSpecifyOthers: boolean;
  candidateEmail: any;
  email: any;
  userType
  isEmail = false
  displyError: any
  heartMedicationStatus = false;
  respiratoryMedicationStatus = false;
  neurologicalDisease1Status = false;
  weakness1Status = false;
  mentalHealth1Status = false;
  musculoskeletal1Status = false;
  sleepDisorder1Status = false;
  endocrineDisorder1Status = false;
  behaviouralDisorder1Status = false;
  hearingDisorder1Status = false;
  speech1ChangeStatus = false;
  bowelDisorder1Status = false;
  kidneyDisorder1Status = false;
  liverDisorder1Status = false;
  isDOB = false
  constructor(
    public _mpJobService: MpjobService,
    public _snackBar: MatSnackBar,
    public formBuilder: FormBuilder,
    public dialog: MatDialog,
    public activatedRoute: ActivatedRoute,
    public dateFormate: ChangeDateFormateService,
    public medicalSerive: MedicalFromService,
    public _cd: ChangeDetectorRef,
    public _userDocumentService: UserDocumentService
  ) {
    let date = new Date()
    this.days = this.generateRange(1, 31)
    this.months = this.generateRange(1, 12),
      this.years = this.generateRange(1950, date.getFullYear())
  }

  ngOnInit() {

    let date = new Date().getTimezoneOffset()
    console.log("when page is load get timezone", date);


    this.activatedRoute.params.subscribe(params => {
      console.log("Params", params)
      if (params.jobid) {
        this.jobId = params.jobid
      }
      if (params.id) {
        this.userId = params.id
      }
    })
    this.createForm()


    this.activatedRoute.queryParams.subscribe(qparam => {
      if (qparam && (qparam.isTestedIndividual == true || qparam.isTestedIndividual == 'true')) {
        console.log('It Means Open From User Profile', this.userId);
        this.getCandidates(qparam.jobId, this.userId)
        this.candidateDisabled = true;
      }
    })



    console.log('consenFormData===== while edit', this.consenFormData);
  }

  ngOnChanges(changes: SimpleChanges) {
    console.log("IN ON CHANGES", changes);

    if (changes.consenFormData && changes.consenFormData.currentValue) {
      this.consentEdit = changes.consenFormData.currentValue;

      if (this.consentEdit.personalDetails && this.consentEdit.personalDetails.dob) {
        let temp = this.consentEdit.personalDetails.dob.split('/')
        this.selectedDay = Number(temp[0])
        this.selectedMonth = Number(temp[1])
        this.selectedYear = Number(temp[2])
      }
      if (this.consentEdit.confirm && this.consentEdit.confirm.confirmSign) {
        this.confirmationSign = this.consentEdit.confirm.confirmSign
        this.confirmationForm.patchValue({
          confirmSign: this.confirmationSign
        })
        this.confirmationForm.updateValueAndValidity()
      }
      // if (this.consentEdit.confirm && this.consentEdit.confirm.confirmDate) {
      //   let temp = this.consentEdit.confirm.confirmDate.split('/')
      //   this.selectedConfirmDay = Number(temp[0])
      //   this.selectedConfirmMonth = Number(temp[1])
      //   this.selectedConfirmYear = Number(temp[2])
      // }
      console.log("valaue of consent form=======", this.consentEdit);
      if (this.consentEdit.form1 && this.consentEdit.form1.idConfirmed.includes('Other')) this.showSpecifyOthers = true
      else this.showSpecifyOthers = false
      // confirm.confirmDate
      this.jobTitle = this.consentEdit.personalDetails && this.consentEdit.personalDetails.jobTitle ? this.consentEdit.personalDetails.jobTitle : '';
      this.email = this.consentEdit.personalDetails && this.consentEdit.personalDetails.email ? this.consentEdit.personalDetails.email : '';

      this.userType = this.consentEdit.personalDetails && this.consentEdit.personalDetails.userType ? this.consentEdit.personalDetails.userType : '';
      // this.name = this.consentEdit.personalDetails.name;
    }

    if (this.consentEdit && this.consentEdit.medicalHistory) {
      console.log("medical history details", this.consentEdit.medicalHistory);
      if (this.consentEdit.medicalHistory && this.consentEdit.medicalHistory.heartDisease2) {
        if (this.consentEdit.medicalHistory.heartDisease1 == 'Yes') this.heartMedicationStatus = true
        let heartDisease2 = this.consentEdit.medicalHistory.heartDisease2.split('<br>')
        console.log("what is the final output of array =======", heartDisease2);

        const array = new FormArray([]);
        _.forEach(heartDisease2, async (client) => {
          await array.push(this.formBuilder.group({
            heartDisease2Name: new FormControl(client),
          }))
        })
        this.medicalHistoryForm.setControl('heartDisease2Array', array)
      }

      if (this.consentEdit.medicalHistory && this.consentEdit.medicalHistory.respiratoryDisease2) {
        if (this.consentEdit.medicalHistory.respiratoryDisease1 == 'Yes') this.respiratoryMedicationStatus = true
        let heartDisease2 = this.consentEdit.medicalHistory.respiratoryDisease2.split('<br>')
        const array = new FormArray([]);
        _.forEach(heartDisease2, async (client) => {
          await array.push(this.formBuilder.group({
            respiratoryDisease2Name: new FormControl(client),
          }))
        })
        this.medicalHistoryForm.setControl('respiratoryDisease2Array', array)
      }

      if (this.consentEdit.medicalHistory && this.consentEdit.medicalHistory.neurologicalDisease2) {
        if (this.consentEdit.medicalHistory.neurologicalDisease1 == 'Yes') this.neurologicalDisease1Status = true
        let heartDisease2 = this.consentEdit.medicalHistory.neurologicalDisease2.split('<br>')
        const array = new FormArray([]);
        _.forEach(heartDisease2, async (client) => {
          await array.push(this.formBuilder.group({
            neurologicalDisease2Name: new FormControl(client),
          }))
        })
        this.medicalHistoryForm.setControl('neurologicalDisease2Array', array)
      }


      if (this.consentEdit.medicalHistory && this.consentEdit.medicalHistory.weakness2) {
        if (this.consentEdit.medicalHistory.weakness1 == 'Yes') this.weakness1Status = true
        let weakness2 = this.consentEdit.medicalHistory.weakness2.split('<br>')
        const array = new FormArray([]);
        _.forEach(weakness2, async (client) => {
          await array.push(this.formBuilder.group({
            weakness2Name: new FormControl(client),
          }))
        })
        this.medicalHistoryForm.setControl('weakness2Array', array)
      }


      if (this.consentEdit.medicalHistory && this.consentEdit.medicalHistory.mentalHealth2) {
        if (this.consentEdit.medicalHistory.mentalHealth1 == 'Yes') this.mentalHealth1Status = true
        let weakness2 = this.consentEdit.medicalHistory.mentalHealth2.split('<br>')
        const array = new FormArray([]);
        _.forEach(weakness2, async (client) => {
          await array.push(this.formBuilder.group({
            mentalHealth2Name: new FormControl(client),
          }))
        })
        this.medicalHistoryForm.setControl('mentalHealth2Array', array)
      }



      if (this.consentEdit.medicalHistory && this.consentEdit.medicalHistory.musculoskeletal2) {
        if (this.consentEdit.medicalHistory.musculoskeletal1 == 'Yes') this.musculoskeletal1Status = true
        let weakness2 = this.consentEdit.medicalHistory.musculoskeletal2.split('<br>')
        const array = new FormArray([]);
        _.forEach(weakness2, async (client) => {
          await array.push(this.formBuilder.group({
            musculoskeletal2Name: new FormControl(client),
          }))
        })
        this.medicalHistoryForm.setControl('musculoskeletal2Array', array)
      }



      if (this.consentEdit.medicalHistory && this.consentEdit.medicalHistory.sleepDisorder1Details) {
        if (this.consentEdit.medicalHistory.sleepDisorder1 == 'Yes') this.sleepDisorder1Status = true
        let weakness2 = this.consentEdit.medicalHistory.sleepDisorder1Details.split('<br>')
        const array = new FormArray([]);
        _.forEach(weakness2, async (client) => {
          await array.push(this.formBuilder.group({
            sleepDisorder1DetailsName: new FormControl(client),
          }))
        })
        this.medicalHistoryForm.setControl('sleepDisorder1DetailsArray', array)
      }


      if (this.consentEdit.medicalHistory && this.consentEdit.medicalHistory.endocrineDisorder2) {
        if (this.consentEdit.medicalHistory.endocrineDisorder1 == 'Yes') this.endocrineDisorder1Status = true
        let weakness2 = this.consentEdit.medicalHistory.endocrineDisorder2.split('<br>')
        const array = new FormArray([]);
        _.forEach(weakness2, async (client) => {
          await array.push(this.formBuilder.group({
            endocrineDisorder2Name: new FormControl(client),
          }))
        })
        this.medicalHistoryForm.setControl('endocrineDisorder2Array', array)
      }


      if (this.consentEdit.medicalHistory && this.consentEdit.medicalHistory.behaviouralDisorder2) {
        if (this.consentEdit.medicalHistory.behaviouralDisorder1 == 'Yes') this.behaviouralDisorder1Status = true
        let weakness2 = this.consentEdit.medicalHistory.behaviouralDisorder2.split('<br>')
        const array = new FormArray([]);
        _.forEach(weakness2, async (client) => {
          await array.push(this.formBuilder.group({
            behaviouralDisorder2Name: new FormControl(client),
          }))
        })
        this.medicalHistoryForm.setControl('behaviouralDisorder2Array', array)
      }


      if (this.consentEdit.medicalHistory && this.consentEdit.medicalHistory.hearingDisorder2) {
        if (this.consentEdit.medicalHistory.hearingDisorder1 == 'Yes') this.hearingDisorder1Status = true
        let weakness2 = this.consentEdit.medicalHistory.hearingDisorder2.split('<br>')
        const array = new FormArray([]);
        _.forEach(weakness2, async (client) => {
          await array.push(this.formBuilder.group({
            hearingDisorder2Name: new FormControl(client),
          }))
        })
        this.medicalHistoryForm.setControl('hearingDisorder2Array', array)
      }



      if (this.consentEdit.medicalHistory && this.consentEdit.medicalHistory.speech2) {
        if (this.consentEdit.medicalHistory.speech1 == 'Yes') this.speech1ChangeStatus = true
        let weakness2 = this.consentEdit.medicalHistory.speech2.split('<br>')
        const array = new FormArray([]);
        _.forEach(weakness2, async (client) => {
          await array.push(this.formBuilder.group({
            speech2Name: new FormControl(client),
          }))
        })
        this.medicalHistoryForm.setControl('speech2Array', array)
      }


      if (this.consentEdit.medicalHistory && this.consentEdit.medicalHistory.bowelDisorder2) {
        if (this.consentEdit.medicalHistory.bowelDisorder1 == 'Yes') this.bowelDisorder1Status = true
        let weakness2 = this.consentEdit.medicalHistory.bowelDisorder2.split('<br>')
        const array = new FormArray([]);
        _.forEach(weakness2, async (client) => {
          await array.push(this.formBuilder.group({
            bowelDisorder2Name: new FormControl(client),
          }))
        })
        this.medicalHistoryForm.setControl('bowelDisorder2Array', array)
      }



      if (this.consentEdit.medicalHistory && this.consentEdit.medicalHistory.kidneyDisorder2) {
        if (this.consentEdit.medicalHistory.kidneyDisorder1 == 'Yes') this.kidneyDisorder1Status = true
        let weakness2 = this.consentEdit.medicalHistory.kidneyDisorder2.split('<br>')
        const array = new FormArray([]);
        _.forEach(weakness2, async (client) => {
          await array.push(this.formBuilder.group({
            kidneyDisorder2Name: new FormControl(client),
          }))
        })
        this.medicalHistoryForm.setControl('kidneyDisorder2Array', array)
      }


      if (this.consentEdit.medicalHistory && this.consentEdit.medicalHistory.liverDisorder2) {
        if (this.consentEdit.medicalHistory.liverDisorder1 == 'Yes') this.liverDisorder1Status = true
        let weakness2 = this.consentEdit.medicalHistory.liverDisorder2.split('<br>')
        const array = new FormArray([]);
        _.forEach(weakness2, async (client) => {
          await array.push(this.formBuilder.group({
            liverDisorder2Name: new FormControl(client),
          }))
        })
        this.medicalHistoryForm.setControl('liverDisorder2Array', array)
      }


      if (this.consentEdit.medicalHistory && this.consentEdit.medicalHistory.allerigies2) {
        if (this.consentEdit.medicalHistory.allerigies1 == 'Yes') this.allerigies2Status = true
        let weakness2 = this.consentEdit.medicalHistory.allerigies2.split('<br>')
        const array = new FormArray([]);
        _.forEach(weakness2, async (client) => {
          await array.push(this.formBuilder.group({
            allerigies2Name: new FormControl(client),
          }))
        })
        this.medicalHistoryForm.setControl('allerigies2Array', array)
      }


      if (this.consentEdit.medicalHistory.heartDisease == "Yes") this.heartDiseaseStatus = true

      if (this.consentEdit.medicalHistory.respiratoryDisease == "Yes") this.respiratoryDiseaseStatus = true

      if (this.consentEdit.medicalHistory.neurologicalDisease == "Yes") this.neurologicalDiseaseStatus = true

      if (this.consentEdit.medicalHistory.weakness == "Yes") this.weaknessStatus = true

      if (this.consentEdit.medicalHistory.mentalHealth == "Yes") this.mentalHealthStatus = true

      if (this.consentEdit.medicalHistory.musculoskeletal == "Yes") this.musculoskeletalStatus = true

      if (this.consentEdit.medicalHistory.sleepDisorder == "Yes") this.sleepDisorderStatus = true

      if (this.consentEdit.medicalHistory.endocrineDisorder == "Yes") this.endocrineDisorderStatus = true

      if (this.consentEdit.medicalHistory.behaviouralDisorder == "Yes") this.behaviouralDisorderStatus = true

      if (this.consentEdit.medicalHistory.visualDisorder == "Yes") this.visualDisorderStatus = true

      if (this.consentEdit.medicalHistory.hearingDisorder == "Yes") this.hearingDisorderStatus = true

      if (this.consentEdit.medicalHistory.speech == "Yes") this.speechStatus = true

      if (this.consentEdit.medicalHistory.bowelDisorder == "Yes") this.bowelDisorderStatus = true

      if (this.consentEdit.medicalHistory.kidneyDisorder == "Yes") this.kidneyDisorderStatus = true

      if (this.consentEdit.medicalHistory.liverDisorder == "Yes") this.liverDisorderStatus = true

      if (this.consentEdit.medicalHistory.allerigies == "Yes") this.allerigiesStatus = true

      if (this.consentEdit.medicalHistory.allerigies1 == "Yes") this.allerigies2Status = true

      if (this.consentEdit.medicalHistory.sleep == "Yes") this.sleepStatus = true

      if (this.consentEdit.medicalHistory.medication == "Yes") this.medicationStatus = true

      if (this.consentEdit.medicalHistory.treatments == "Yes") this.treatmentsStatus = true

      if (this.consentEdit.medicalHistory.tests == "Yes") this.testsStatus = true

      if (this.consentEdit.medicalHistory.healthAspect == "Yes") this.healthAspectStatus = true, this._cd.detectChanges()

      if (this.consentEdit.medicalHistory.visualDisorder6 == "Yes") this.visualDisorder6Status = true
      this._cd.detectChanges()

    }

    if (changes.candidateList && changes.candidateList.currentValue) {
      this.getCommonDetails()
    }

    console.log('this.consentEdit===>', this.consentEdit);
  }


  createForm() {
    // PERSONAL DETAILS
    this.personalDetailsForm = this.formBuilder.group({
      name: ['', Validators.required],
      dob: new FormControl('', Validators.required),
      email: new FormControl(''),
      telNumber: new FormControl(''),
      sponsorName: new FormControl('', Validators.required),
      jobTitle: new FormControl(''), /* DISPLAY JOB TITLE BY DEFAULt */
      homeAdd: new FormControl(''),
      gpAdd: new FormControl(''),
      idConfirmed: new FormControl('', Validators.required),
      idConfirmOther: new FormControl(''),
      currentSenCard: new FormControl('', Validators.required),
      natInstNo: new FormControl('', Validators.required),
      sentinalNo: new FormControl(''),
      comment: new FormControl('')
    })

    // EMPLOYMENT HISTORY
    this.employmentHistoryForm = this.formBuilder.group({
      absent: new FormControl(''),
      absentDetails: new FormControl(''),
      deniedJob: new FormControl(''),
      jobDeniedDetails: new FormControl(''),
      illness: new FormControl(''),
      illnessDetails: new FormControl(''),
      comment: new FormControl('')
    })
    // MEDICAL HISTORY
    this.medicalHistoryForm = this.formBuilder.group({
      heartDisease: new FormControl(''),
      heartDiseaseDetails: new FormControl(''),
      heartDisease1: new FormControl(''),
      heartDisease2Array: this.formBuilder.array(this.heartDisease2()),
      heartDiseaseSideEffect: new FormControl(''),
      heartDisease2: new FormControl(''),
      heartDisease3: new FormControl(''),
      heartDisease4: new FormControl(''),
      heartDisease5: new FormControl(''),
      respiratoryDisease: new FormControl(''),
      respiratoryDiseaseDetails: new FormControl(''),
      respiratoryDisease1: new FormControl(''),
      respiratoryDisease2Array: this.formBuilder.array(this.respiratoryDisease2()),
      respiratoryDiseaseSideEffect: new FormControl(''),
      respiratoryDisease2: new FormControl(''),
      respiratoryDisease3: new FormControl(''),
      respiratoryDisease4: new FormControl(''),
      respiratoryDisease5: new FormControl(''),
      neurologicalDisease: new FormControl(''),
      neurologicalDiseaseDetails: new FormControl(''),
      neurologicalDisease1: new FormControl(''),
      neurologicalDisease2Array: this.formBuilder.array(this.neurologicalDisease2()),
      neurologicalDiseaseSideEffect: new FormControl(''),
      neurologicalDisease2: new FormControl(''),
      neurologicalDisease3: new FormControl(''),
      neurologicalDisease4: new FormControl(''),
      neurologicalDisease5: new FormControl(''),
      neurologicalDisease6: new FormControl(''),
      weakness: new FormControl(''),
      weaknessDetails: new FormControl(''),
      weakness1: new FormControl(''),
      weakness2Array: this.formBuilder.array(this.weakness2()),
      weaknessSideEffect: new FormControl(''),
      weakness2: new FormControl(''),
      weakness3: new FormControl(''),
      weakness4: new FormControl(''),
      weakness5: new FormControl(''),
      mentalHealth: new FormControl(''),
      mentalHealthDetails: new FormControl(''),
      mentalHealth1: new FormControl(''),
      mentalHealth2Array: this.formBuilder.array(this.mentalHealth2()),
      mentalHealthSideEffect: new FormControl(''),
      mentalHealthSuicidal: new FormControl(''),
      mentalHealth2: new FormControl(''),
      mentalHealth3: new FormControl(''),
      mentalHealth4: new FormControl(''),
      mentalHealth5: new FormControl(''),
      musculoskeletal: new FormControl(''),
      musculoskeletalDetails: new FormControl(''),
      musculoskeletal1: new FormControl(''),
      musculoskeletal2Array: this.formBuilder.array(this.musculoskeletal2()),
      musculoskeletalSideEffect: new FormControl(''),
      musculoskeletal2: new FormControl(''),
      musculoskeletal3: new FormControl(''),
      musculoskeletal4: new FormControl(''),
      musculoskeletal5: new FormControl(''),
      sleepDisorder: new FormControl(''),
      sleepDisorderDetails: new FormControl(''),
      sleepDisorder1: new FormControl(''),
      sleepDisorder1DetailsArray: this.formBuilder.array(this.sleepDisorder1Details()),
      sleepDisorderSideEffect: new FormControl(''),
      sleepDisorder1Details: new FormControl(''),
      sleepDisorder2: new FormControl(''),
      sleepDisorder2Details: new FormControl(''),
      sleepDisorder3: new FormControl(''),
      sleepDisorder3Details: new FormControl(''),
      sleepDisorder4: new FormControl(''),
      sleepDisorder4Details: new FormControl(''),
      sleepDisorder5: new FormControl(''),
      sleepDisorder5Details: new FormControl(''),
      sleepDisorder6: new FormControl(''),
      sleepDisorder6Details: new FormControl(''),
      endocrineDisorder: new FormControl(''),
      endocrineDisorderDetails: new FormControl(''),
      endocrineDisorder1: new FormControl(''),
      endocrineDisorder2Array: this.formBuilder.array(this.endocrineDisorder2()),
      endocrineDisorderSideEffect: new FormControl(''),
      endocrineDisorder2: new FormControl(''),
      endocrineDisorder3: new FormControl(''),
      endocrineDisorder4: new FormControl(''),
      endocrineDisorder5: new FormControl(''),
      behaviouralDisorder: new FormControl(''),
      behaviouralDisorderDetails: new FormControl(''),
      behaviouralDisorder1: new FormControl(''),
      behaviouralDisorder2Array: this.formBuilder.array(this.behaviouralDisorder2()),
      behaviouralDisorderSideEffect: new FormControl(''),
      behaviouralDisorder2: new FormControl(''),
      behaviouralDisorder3: new FormControl(''),
      behaviouralDisorder4: new FormControl(''),
      behaviouralDisorder5: new FormControl(''),
      visualDisorder: new FormControl(''),
      visualDisorderDetails: new FormControl(''),
      visualDisorder1: new FormControl(''),
      visualDisorder2: new FormControl(''),
      visualDisorder3: new FormControl(''),
      visualDisorder4: new FormControl(''),
      visualDisorder5: new FormControl(''),
      visualDisorder6: new FormControl(''),
      visualDisorder7: new FormControl(''),
      hearingDisorder: new FormControl(''),
      hearingDisorderDetails: new FormControl(''),
      hearingDisorder1: new FormControl(''),
      hearingDisorder2Array: this.formBuilder.array(this.hearingDisorder2()),
      hearingDisorderSideEffect: new FormControl(''),
      hearingDisorder2: new FormControl(''),
      hearingDisorder3: new FormControl(''),
      hearingDisorder4: new FormControl(''),
      hearingDisorder5: new FormControl(''),
      speech: new FormControl(''),
      speechDetails: new FormControl(''),
      speech1: new FormControl(''),
      speech2Array: this.formBuilder.array(this.speech2()),
      speechSideEffect: new FormControl(''),
      speech2: new FormControl(''),
      speech3: new FormControl(''),
      speech4: new FormControl(''),
      speech5: new FormControl(''),
      bowelDisorder: new FormControl(''),
      bowelDisorderDetails: new FormControl(''),
      bowelDisorder1: new FormControl(''),
      bowelDisorder2Array: this.formBuilder.array(this.bowelDisorder2()),
      bowelDisorderSideEffect: new FormControl(''),
      bowelDisorder2: new FormControl(''),
      bowelDisorder3: new FormControl(''),
      bowelDisorder4: new FormControl(''),
      bowelDisorder5: new FormControl(''),
      kidneyDisorder: new FormControl(''),
      kidneyDisorderDetails: new FormControl(''),
      kidneyDisorder1: new FormControl(''),
      kidneyDisorder2Array: this.formBuilder.array(this.kidneyDisorder2()),
      kidneyDisorderSideEffect: new FormControl(''),
      kidneyDisorder2: new FormControl(''),
      kidneyDisorder3: new FormControl(''),
      kidneyDisorder4: new FormControl(''),
      kidneyDisorder5: new FormControl(''),
      liverDisorder: new FormControl(''),
      liverDisorderDetails: new FormControl(''),
      liverDisorder1: new FormControl(''),
      liverDisorder2Array: this.formBuilder.array(this.liverDisorder2()),
      liverDisorderSideEffect: new FormControl(''),
      liverDisorder2: new FormControl(''),
      liverDisorder3: new FormControl(''),
      liverDisorder4: new FormControl(''),
      liverDisorder5: new FormControl(''),
      allerigies: new FormControl(''),
      allerigiesDetails: new FormControl(''),
      allerigies1: new FormControl(''),
      allerigies1Details: new FormControl(''),
      allerigies2Array: this.formBuilder.array(this.allerigies2()),
      allerigiesSideEffect: new FormControl(''),
      allerigies2: new FormControl(''),
      sleep: new FormControl(''),
      sleepDetails: new FormControl(''),
      sleep1: new FormControl(''),
      sleep2: new FormControl(''),
      sleep3: new FormControl(''),
      medication: new FormControl(''),
      medicationDetails: new FormControl(''),
      medication1: new FormControl(''),
      medication2: new FormControl(''),
      medication3: new FormControl(''),
      treatments: new FormControl(''),
      treatmentsDetails: new FormControl(''),
      treatments1: new FormControl(''),
      treatments2: new FormControl(''),
      treatments3: new FormControl(''),
      tests: new FormControl(''),
      testsDetails: new FormControl(''),
      tests1: new FormControl(''),
      tests2: new FormControl(''),
      tests3: new FormControl(''),
      healthAspect: new FormControl(''),
      healthAspectDetails: new FormControl(''),
      healthAspect1: new FormControl(''),
      healthAspect2: new FormControl(''),
      healthAspect3: new FormControl(''),
      comment: new FormControl('')
    })
    //LIFESTYLE
    this.lifestyleForm = this.formBuilder.group({
      exercise: new FormControl(''),
      exerciseDetails: new FormControl(''),
      smoke: new FormControl(''),
      smokeDetails: new FormControl(''),
      exsmoker: new FormControl(''),
      exsmokerYears: new FormControl(''),
      exsmokerMonths: new FormControl(''),
      alcohol: new FormControl(''),
      alcoholDetails: new FormControl(''),
      comment: new FormControl('')
    })
    //CONFIRMATION
    this.confirmationForm = this.formBuilder.group({
      sponsorName: new FormControl(''),
      confirmDate: new FormControl('', Validators.required),
      confirmSign: new FormControl('', Validators.required)
    })
  }


  // heartDisease2

  get multipleheartDisease2() { return <FormArray>this.medicalHistoryForm.get('heartDisease2Array') }

  heartDisease2() {
    return [this.formBuilder.group({
      heartDisease2Name: new FormControl(''),
    })
    ]
  }

  addHeartDisease2() {
    const control = <FormArray>this.medicalHistoryForm.controls.heartDisease2Array

    control.push(this.formBuilder.group({
      heartDisease2Name: new FormControl(''),
    }))
  }

  deleteHeartDisease2(index) {
    const control = <FormArray>this.medicalHistoryForm.controls.heartDisease2Array
    control.removeAt(index)
  }


  // respiratoryDisease2

  get multiplerespiratoryDisease2() { return <FormArray>this.medicalHistoryForm.get('respiratoryDisease2Array') }

  respiratoryDisease2() {
    return [this.formBuilder.group({
      respiratoryDisease2Name: new FormControl(''),
    })
    ]
  }


  addRespiratoryDisease2() {
    const control = <FormArray>this.medicalHistoryForm.controls.respiratoryDisease2Array

    control.push(this.formBuilder.group({
      respiratoryDisease2Name: new FormControl(''),
    }))
  }

  deleteRespiratoryDisease2(index) {
    const control = <FormArray>this.medicalHistoryForm.controls.respiratoryDisease2Array
    control.removeAt(index)
  }


  // weakness2

  get multipleweakness2() { return <FormArray>this.medicalHistoryForm.get('weakness2Array') }

  weakness2() {
    return [this.formBuilder.group({
      weakness2Name: new FormControl(''),
    })
    ]
  }

  addweakness2() {
    const control = <FormArray>this.medicalHistoryForm.controls.weakness2Array

    control.push(this.formBuilder.group({
      weakness2Name: new FormControl(''),
    }))
  }
  deleteweakness2(index) {
    const control = <FormArray>this.medicalHistoryForm.controls.weakness2Array
    control.removeAt(index)
  }




  // NeurologicalDisease2
  get multipleNeurologicalDisease2() { return <FormArray>this.medicalHistoryForm.get('neurologicalDisease2Array') }

  neurologicalDisease2() {
    return [this.formBuilder.group({
      neurologicalDisease2Name: new FormControl(''),
    })
    ]
  }

  addNeurologicalDisease2() {
    const control = <FormArray>this.medicalHistoryForm.controls.neurologicalDisease2Array

    control.push(this.formBuilder.group({
      neurologicalDisease2Name: new FormControl(''),
    }))
  }
  deleteNeurologicalDisease2(index) {
    const control = <FormArray>this.medicalHistoryForm.controls.neurologicalDisease2Array
    control.removeAt(index)
  }





  // mentalHealth

  get multipleMentalHealth2() { return <FormArray>this.medicalHistoryForm.get('mentalHealth2Array') }

  mentalHealth2() {
    return [this.formBuilder.group({
      mentalHealth2Name: new FormControl(''),
    })
    ]
  }

  addMentalHealth2() {
    const control = <FormArray>this.medicalHistoryForm.controls.mentalHealth2Array

    control.push(this.formBuilder.group({
      mentalHealth2Name: new FormControl(''),
    }))
  }
  deleteMentalHealth2(index) {
    const control = <FormArray>this.medicalHistoryForm.controls.mentalHealth2Array
    control.removeAt(index)
  }






  // musculoskeletal2

  get multipleMusculoskeletal2() { return <FormArray>this.medicalHistoryForm.get('musculoskeletal2Array') }

  musculoskeletal2() {
    return [this.formBuilder.group({
      musculoskeletal2Name: new FormControl(''),
    })
    ]
  }

  addMusculoskeletal2() {
    const control = <FormArray>this.medicalHistoryForm.controls.musculoskeletal2Array

    control.push(this.formBuilder.group({
      musculoskeletal2Name: new FormControl(''),
    }))
  }
  deleteMusculoskeletal2(index) {
    const control = <FormArray>this.medicalHistoryForm.controls.musculoskeletal2Array
    control.removeAt(index)
  }





  // sleepDisorder1Details

  get multipleSleepDisorder1Details() { return <FormArray>this.medicalHistoryForm.get('sleepDisorder1DetailsArray') }


  sleepDisorder1Details() {
    return [this.formBuilder.group({
      sleepDisorder1DetailsName: new FormControl(''),
    })
    ]
  }


  addSleepDisorder1Details() {
    const control = <FormArray>this.medicalHistoryForm.controls.sleepDisorder1DetailsArray

    control.push(this.formBuilder.group({
      sleepDisorder1DetailsName: new FormControl(''),
    }))
  }
  deleteSleepDisorder1Details(index) {
    const control = <FormArray>this.medicalHistoryForm.controls.sleepDisorder1DetailsArray
    control.removeAt(index)
  }



  // endocrineDisorder2


  get multipleEndocrineDisorder2() { return <FormArray>this.medicalHistoryForm.get('endocrineDisorder2Array') }


  endocrineDisorder2() {
    return [this.formBuilder.group({
      endocrineDisorder2Name: new FormControl(''),
    })
    ]
  }


  addEndocrineDisorder2() {
    const control = <FormArray>this.medicalHistoryForm.controls.endocrineDisorder2Array

    control.push(this.formBuilder.group({
      endocrineDisorder2Name: new FormControl(''),
    }))
  }
  deleteEndocrineDisorder2(index) {
    const control = <FormArray>this.medicalHistoryForm.controls.endocrineDisorder2Array
    control.removeAt(index)
  }



  // behaviouralDisorder2


  get multipleBehaviouralDisorder2() { return <FormArray>this.medicalHistoryForm.get('behaviouralDisorder2Array') }


  behaviouralDisorder2() {
    return [this.formBuilder.group({
      behaviouralDisorder2Name: new FormControl(''),
    })
    ]
  }


  addBehaviouralDisorder2() {
    const control = <FormArray>this.medicalHistoryForm.controls.behaviouralDisorder2Array

    control.push(this.formBuilder.group({
      behaviouralDisorder2Name: new FormControl(''),
    }))
  }
  deleteBehaviouralDisorder2(index) {
    const control = <FormArray>this.medicalHistoryForm.controls.behaviouralDisorder2Array
    control.removeAt(index)
  }


  // hearingDisorder2

  get multipleHearingDisorder2() { return <FormArray>this.medicalHistoryForm.get('hearingDisorder2Array') }


  hearingDisorder2() {
    return [this.formBuilder.group({
      hearingDisorder2Name: new FormControl(''),
    })
    ]
  }


  addHearingDisorder2() {
    const control = <FormArray>this.medicalHistoryForm.controls.hearingDisorder2Array

    control.push(this.formBuilder.group({
      hearingDisorder2Name: new FormControl(''),
    }))
  }
  deleteHearingDisorder2(index) {
    const control = <FormArray>this.medicalHistoryForm.controls.hearingDisorder2Array
    control.removeAt(index)
  }

  // speech2

  get multipleSpeech2() { return <FormArray>this.medicalHistoryForm.get('speech2Array') }


  speech2() {
    return [this.formBuilder.group({
      speech2Name: new FormControl(''),
    })
    ]
  }


  addSpeech2() {
    const control = <FormArray>this.medicalHistoryForm.controls.speech2Array

    control.push(this.formBuilder.group({
      speech2Name: new FormControl(''),
    }))
  }
  deleteSpeech2(index) {
    const control = <FormArray>this.medicalHistoryForm.controls.speech2Array
    control.removeAt(index)
  }



  // bowelDisorder2


  get multipleBowelDisorder2() { return <FormArray>this.medicalHistoryForm.get('bowelDisorder2Array') }


  bowelDisorder2() {
    return [this.formBuilder.group({
      bowelDisorder2Name: new FormControl(''),
    })
    ]
  }


  addBowelDisorder2() {
    const control = <FormArray>this.medicalHistoryForm.controls.bowelDisorder2Array

    control.push(this.formBuilder.group({
      bowelDisorder2Name: new FormControl(''),
    }))
  }
  deleteBowelDisorder2(index) {
    const control = <FormArray>this.medicalHistoryForm.controls.bowelDisorder2Array
    control.removeAt(index)
  }



  // kidneyDisorder2

  get multipleKidneyDisorder2() { return <FormArray>this.medicalHistoryForm.get('kidneyDisorder2Array') }


  kidneyDisorder2() {
    return [this.formBuilder.group({
      kidneyDisorder2Name: new FormControl(''),
    })
    ]
  }


  addKidneyDisorder2() {
    const control = <FormArray>this.medicalHistoryForm.controls.kidneyDisorder2Array

    control.push(this.formBuilder.group({
      kidneyDisorder2Name: new FormControl(''),
    }))
  }
  deleteKidneyDisorder2(index) {
    const control = <FormArray>this.medicalHistoryForm.controls.kidneyDisorder2Array
    control.removeAt(index)
  }



  // liverDisorder2

  get multipleLiverDisorder2() { return <FormArray>this.medicalHistoryForm.get('liverDisorder2Array') }

  liverDisorder2() {
    return [this.formBuilder.group({
      liverDisorder2Name: new FormControl(''),
    })
    ]
  }


  addLiverDisorder2() {
    const control = <FormArray>this.medicalHistoryForm.controls.liverDisorder2Array

    control.push(this.formBuilder.group({
      liverDisorder2Name: new FormControl(''),
    }))
  }

  deleteLiverDisorder2(index) {
    const control = <FormArray>this.medicalHistoryForm.controls.liverDisorder2Array
    control.removeAt(index)
  }

  // allerigies2


  get multipleAllerigies2() { return <FormArray>this.medicalHistoryForm.get('allerigies2Array') }

  allerigies2() {
    return [this.formBuilder.group({
      allerigies2Name: new FormControl(''),
    })
    ]
  }


  addAllerigies2() {
    const control = <FormArray>this.medicalHistoryForm.controls.allerigies2Array

    control.push(this.formBuilder.group({
      allerigies2Name: new FormControl(''),
    }))
  }

  deleteAllerigies2(index) {
    const control = <FormArray>this.medicalHistoryForm.controls.allerigies2Array
    control.removeAt(index)
  }

  sponsorNameAdded(event) {
    console.log("event ----------", event)
    let tempName = event.target.value
    if (tempName) {
      this.confirmationForm.patchValue({
        sponsorName: tempName
      })
    }
  }
  generateRange(start, end) {
    return _.range(start, end + 1, 1)
  }

  redirect() {
    // this.router.navigateByUrl('/signature')
    this.openDialog(SignaturePadComponent).subscribe(data => {
      console.log("data from signature", data)
      this.confirmationSign = data
      this.showSignErr = false
      this.confirmationForm.patchValue({
        confirmSign: this.confirmationSign
      })
    })
  }

  openDialog(someComponent, data = {}): Observable<any> {
    console.log("OPENDIALOG", "DATA = ", data);
    const dialogRef = this.dialog.open(someComponent, {
      data, maxWidth: '100vw',
      maxHeight: '100vh',
      height: '100%',
      width: '100%'
    });
    return dialogRef.afterClosed();
  }

  idChanged(event) {
    console.log("Id confirm changed", event)
    if (event.value.includes('Other')) this.showSpecifyOthers = true
    else this.showSpecifyOthers = false
  }
  checkDOB(stepper: MatStepper) {
    console.log("what is the stepper value", stepper);

    console.log("when click on next event", this.personalDetailsForm.value);
    console.log("value of date of birth", this.selectedDay, this.selectedMonth, this.selectedYear);
    if (this.selectedDay == undefined || this.selectedMonth == undefined || this.selectedYear == undefined) this.isDOB = true
    else this.isDOB = false, this.personalDetailsForm.patchValue({ dob: this.selectedDay + '/' + this.selectedMonth + '/' + this.selectedYear }), stepper.next()
  }

  candidateChosen(event) {
    console.log('candidate chosen ==========', event)
  }
  optionClicked(candidate) {
    console.log('candidate option clicked ==========', candidate)
    this.user = {
      userId: candidate.userId,
      userType: candidate.userType,
      jobId: candidate.jobId
    }
    this.jobTitle = candidate.jobTitle
    this.email = candidate.email
    this.personalDetailsForm.patchValue({
      jobTitle: this.jobTitle,
      email: candidate.email
    })
  }

  submitConsent() {
    if (this.selectedDay && this.selectedMonth && this.selectedYear) {
      this.personalDetailsForm.patchValue({
        dob: this.selectedDay + '/' + this.selectedMonth + '/' + this.selectedYear
      })
    } else {
      this.personalDetailsForm.patchValue({
        dob: ''
      })
    }


    // if (this.selectedConfirmDay && this.selectedConfirmMonth && this.selectedConfirmYear) {
    //   this.confirmationForm.patchValue({
    //     confirmDate: this.selectedConfirmDay + '/' + this.selectedConfirmMonth + '/' + this.selectedConfirmYear,
    //     // checkedByDate: this.selectedCheckedByDay + '/' + this.selectedCheckedByMonth + '/' + this.selectedCheckedByYear,
    //   })
    // }
    // else {
    // this.confirmationForm.controls.confirmDate.setErrors({
    //   inValid: true
    // })
    // if(this.confirmationSign == undefined){

    // }
    // this.openSnackBar("Date is mandatory", "Ok");
    // this.showSignErr = false
    // }
    console.log('personal details', this.personalDetailsForm)
    console.log('employment history details', this.employmentHistoryForm)
    console.log('medical history details', this.medicalHistoryForm)
    console.log('lifestyle details', this.lifestyleForm)
    console.log('conformation details', this.confirmationForm)


    // heartDisease2

    let heartDisease2 = this.medicalHistoryForm.get('heartDisease2Array').value.map(function (item) {
      return item['heartDisease2Name']
    })
    let heartDisease2String = heartDisease2.join(' <br> ')
    this.medicalHistoryForm.controls.heartDisease2.setValue(heartDisease2String)

    // respiratoryDisease2

    let respiratoryDisease2 = this.medicalHistoryForm.get('respiratoryDisease2Array').value.map(function (item) {
      return item['respiratoryDisease2Name']
    })
    let respiratoryDisease2String = respiratoryDisease2.join(' <br> ')
    this.medicalHistoryForm.controls.respiratoryDisease2.setValue(respiratoryDisease2String)

    // NeurologicalDisease2

    let NeurologicalDisease2 = this.medicalHistoryForm.get('neurologicalDisease2Array').value.map(function (item) {
      return item['neurologicalDisease2Name']
    })
    let neurologicalDisease2String = NeurologicalDisease2.join(' <br> ')
    this.medicalHistoryForm.controls.neurologicalDisease2.setValue(neurologicalDisease2String)

    // weakness2

    let weakness2 = this.medicalHistoryForm.get('weakness2Array').value.map(function (item) {
      return item['weakness2Name']
    })
    let weakness2String = weakness2.join(' <br> ')
    this.medicalHistoryForm.controls.weakness2.setValue(weakness2String)


    // mentalHealth2

    let mentalHealth2 = this.medicalHistoryForm.get('mentalHealth2Array').value.map(function (item) {
      return item['mentalHealth2Name']
    })
    let mentalHealth2String = mentalHealth2.join(' <br> ')
    this.medicalHistoryForm.controls.mentalHealth2.setValue(mentalHealth2String)



    // musculoskeletal2

    let musculoskeletal2 = this.medicalHistoryForm.get('musculoskeletal2Array').value.map(function (item) {
      return item['musculoskeletal2Name']
    })
    let musculoskeletal2String = musculoskeletal2.join(' <br> ')
    this.medicalHistoryForm.controls.musculoskeletal2.setValue(musculoskeletal2String)


    // sleepDisorder1Details


    let sleepDisorder1Details = this.medicalHistoryForm.get('sleepDisorder1DetailsArray').value.map(function (item) {
      return item['sleepDisorder1DetailsName']
    })
    let sleepDisorder1DetailsString = sleepDisorder1Details.join(' <br> ')
    this.medicalHistoryForm.controls.sleepDisorder1Details.setValue(sleepDisorder1DetailsString)


    // endocrineDisorder2

    let endocrineDisorder2 = this.medicalHistoryForm.get('endocrineDisorder2Array').value.map(function (item) {
      return item['endocrineDisorder2Name']
    })
    let endocrineDisorder2String = endocrineDisorder2.join(' <br> ')
    this.medicalHistoryForm.controls.endocrineDisorder2.setValue(endocrineDisorder2String)

    // behaviouralDisorder2

    let behaviouralDisorder2 = this.medicalHistoryForm.get('behaviouralDisorder2Array').value.map(function (item) {
      return item['behaviouralDisorder2Name']
    })
    let behaviouralDisorder2String = behaviouralDisorder2.join(' <br> ')
    this.medicalHistoryForm.controls.behaviouralDisorder2.setValue(behaviouralDisorder2String)


    // hearingDisorder2

    let hearingDisorder2 = this.medicalHistoryForm.get('hearingDisorder2Array').value.map(function (item) {
      return item['hearingDisorder2Name']
    })
    let hearingDisorder2String = hearingDisorder2.join(' <br> ')
    this.medicalHistoryForm.controls.hearingDisorder2.setValue(hearingDisorder2String)

    // speech2

    let speech2 = this.medicalHistoryForm.get('speech2Array').value.map(function (item) {
      return item['speech2Name']
    })
    let speech2String = speech2.join(' <br> ')
    this.medicalHistoryForm.controls.speech2.setValue(speech2String)

    // bowelDisorder2


    let bowelDisorder2 = this.medicalHistoryForm.get('bowelDisorder2Array').value.map(function (item) {
      return item['bowelDisorder2Name']
    })
    let bowelDisorder2String = bowelDisorder2.join(' <br> ')
    this.medicalHistoryForm.controls.bowelDisorder2.setValue(bowelDisorder2String)


    // kidneyDisorder2

    let kidneyDisorder2 = this.medicalHistoryForm.get('kidneyDisorder2Array').value.map(function (item) {
      return item['kidneyDisorder2Name']
    })
    let kidneyDisorder2String = kidneyDisorder2.join(' <br> ')
    this.medicalHistoryForm.controls.kidneyDisorder2.setValue(kidneyDisorder2String)

    // liverDisorder2

    let liverDisorder2 = this.medicalHistoryForm.get('liverDisorder2Array').value.map(function (item) {
      return item['liverDisorder2Name']
    })
    let liverDisorder2String = liverDisorder2.join(' <br> ')
    this.medicalHistoryForm.controls.liverDisorder2.setValue(liverDisorder2String)

    // allerigies2

    let allerigies2 = this.medicalHistoryForm.get('allerigies2Array').value.map(function (item) {
      return item['allerigies2Name']
    })
    let allerigies2String = allerigies2.join(' <br> ')
    this.medicalHistoryForm.controls.allerigies2.setValue(allerigies2String)


    let obj = {
      personalDetails: this.personalDetailsForm.value,
      empHistory: this.employmentHistoryForm.value,
      medicalHistory: this.medicalHistoryForm.value,
      lifeStyle: this.lifestyleForm.value,
      confirm: this.confirmationForm.value
    }

    console.log("what is the final object data", obj);


    if (this.personalDetailsForm.valid && this.confirmationForm.valid) {
      this.consentForm.emit({ consentForm: obj, user: this.user, email: this.isEmail })
      this.extraDetails.emit({ user: this.candidateName })
    }
    else {
      console.log("value of signature attached", this.confirmationSign);
      if (this.confirmationSign == undefined) {
        this.showSignErr = true
      } else {
        this.showSignErr = false
      }
    }
  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }

  getCandidates(jobId, userId) {
    this._mpJobService.getAllCandidateList(jobId).subscribe(res => {
      console.log('candidate list in consent-form component', res)
      this.candidateArray = res
      let index = _.findIndex(this.candidateArray, function (o) {
        return o.userId == userId
      })
      if (index > -1) {
        console.log('seletcted Candidate', this.candidateArray[index])
        this.candidateName = this.candidateArray[index].name
        this.personalDetailsForm.controls.name.setValue(this.candidateName);
        this.user = {
          userId: this.candidateArray[index].userId,
          userType: this.candidateArray[index].userType,
          jobId: this.candidateArray[index].jobId
        }
        this.jobTitle = this.candidateArray[index].jobTitle
        this.email = this.candidateArray[index].email
        this.userType = this.candidateArray[index].userType
      }
    })
  }

  heartDiseaseChange(event) {
    if (event.value == "Yes") this.heartDiseaseStatus = true
    else this.heartDiseaseStatus = false
    this._cd.detectChanges()
  }

  respiratoryDiseaseChange(event) {
    if (event.value == "Yes") this.respiratoryDiseaseStatus = true
    else this.respiratoryDiseaseStatus = false
    this._cd.detectChanges()
  }

  neurologicalDiseaseChange(event) {
    if (event.value == "Yes") this.neurologicalDiseaseStatus = true
    else this.neurologicalDiseaseStatus = false
    this._cd.detectChanges()
  }

  weaknessChange(event) {
    if (event.value == "Yes") this.weaknessStatus = true
    else this.weaknessStatus = false
    this._cd.detectChanges()
  }

  mentalHealthChange(event) {
    if (event.value == "Yes") this.mentalHealthStatus = true
    else this.mentalHealthStatus = false
    this._cd.detectChanges()
  }


  musculoskeletalChange(event) {
    if (event.value == "Yes") this.musculoskeletalStatus = true
    else this.musculoskeletalStatus = false
    this._cd.detectChanges()
  }

  sleepDisorderChange(event) {
    if (event.value == "Yes") this.sleepDisorderStatus = true
    else this.sleepDisorderStatus = false
    this._cd.detectChanges()
  }

  endocrineDisorderChange(event) {
    if (event.value == "Yes") this.endocrineDisorderStatus = true
    else this.endocrineDisorderStatus = false
    this._cd.detectChanges()
  }

  behaviouralDisorderChange(event) {
    if (event.value == "Yes") this.behaviouralDisorderStatus = true
    else this.behaviouralDisorderStatus = false
    this._cd.detectChanges()
  }

  visualDisorderChange(event) {
    if (event.value == "Yes") this.visualDisorderStatus = true
    else this.visualDisorderStatus = false
    this._cd.detectChanges()
  }

  hearingDisorderChange(event) {
    if (event.value == "Yes") this.hearingDisorderStatus = true
    else this.hearingDisorderStatus = false
    this._cd.detectChanges()
  }

  speechChange(event) {
    if (event.value == "Yes") this.speechStatus = true
    else this.speechStatus = false
    this._cd.detectChanges()
  }

  bowelDisorderChange(event) {
    if (event.value == "Yes") this.bowelDisorderStatus = true
    else this.bowelDisorderStatus = false
    this._cd.detectChanges()
  }

  kidneyDisorderChange(event) {
    if (event.value == "Yes") this.kidneyDisorderStatus = true
    else this.kidneyDisorderStatus = false
    this._cd.detectChanges()
  }

  liverDisorderChange(event) {
    if (event.value == "Yes") this.liverDisorderStatus = true
    else this.liverDisorderStatus = false
    this._cd.detectChanges()
  }

  allerigiesChange(event) {
    if (event.value == "Yes") this.allerigiesStatus = true
    else this.allerigiesStatus = false
    this._cd.detectChanges()
  }

  treatmentsChange(event) {
    if (event.value == "Yes") this.treatmentsStatus = true
    else this.treatmentsStatus = false
    this._cd.detectChanges()
  }

  sleepChange(event) {
    if (event.value == "Yes") this.sleepStatus = true
    else this.sleepStatus = false
    this._cd.detectChanges()
  }

  medicationChange(event) {
    if (event.value == "Yes") this.medicationStatus = true
    else this.medicationStatus = false
    this._cd.detectChanges()
  }
  testsChange(event) {
    if (event.value == "Yes") this.testsStatus = true
    else this.testsStatus = false
    this._cd.detectChanges()
  }
  healthAspectChange(event) {
    if (event.value == "Yes") this.healthAspectStatus = true
    else this.healthAspectStatus = false
    this._cd.detectChanges()
  }
  allerigiesStatusChange(event) {
    console.log("event of change status", event);

    if (event.value == "Yes") this.allerigies2Status = true
    else this.allerigies2Status = false
    this._cd.detectChanges()
  }
  visualDisorder6Change(event) {

    if (event.value == "Yes") this.visualDisorder6Status = true
    else this.visualDisorder6Status = false
    this._cd.detectChanges()
  }


  validatePhone(form) {
    console.log(form)
    let field1 = (<HTMLInputElement>document.getElementById("mobile")).value;
    let message = document.getElementById('message3');
    console.log(field1);
    if (/[a-zA-Z]/g.test(field1)) {
      message.innerHTML = "Please enter only numbers"
    }
    else if (!(/[0-9]{10}/.test(field1))) {
      console.log("Please enter valid number");
      if (field1.length < 10) {
        message.innerHTML = "Please enter 10 digit number";
      }
    } else {
      message.innerHTML = ""
      console.log("Valid entry");
    }
  }
  _keyPress(event: any) {
    console.log("event is call or not", event);

    const pattern = /[0-9]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (!pattern.test(inputChar)) {
      event.preventDefault();

    }
  }
  handleDOBChange(event) {
    console.log("event when date is change", event);
    let selectedDate = event.value
    // let finalDate this.dateFormate.convertDate(selectedDate)

    // let finalDate = moment(selectedDate).format("YYYY-MM-DD")
    // console.log("what is the final date of selected", finalDate);
    this.confirmationForm.patchValue({
      confirmDate: this.dateFormate.convertDate(new Date(selectedDate))
    })
    this.confirmationForm.updateValueAndValidity()
  }

  emailCheck(event) {
    console.log("event of mail check", event.target.value);
    console.log("alaready aadded email", this.email);



    if (this.email == event.target.value) {
      console.log("both email changes are same");
      this.isEmail = false
    } else {
      console.log("there is chanage in email id");
      // this.isEmail = true
      this.medicalSerive.checkEmail(event.target.value).subscribe((response) => {
        if (response == true) {
          console.log("resposse of email check", response);
          // this.isEmail = true
          this.displyError = true
          console.log("displaay error value", this.displyError);
          this.personalDetailsForm.controls.email.setErrors({
            inValid: true
          })
        } else {
          this.isEmail = true
        }
      }, error => {
        console.log("error========", error);
      })



    }
  }


  changeMail() {
    console.log("when its from restore", this.email);

    this.personalDetailsForm.controls.email.setValue(this.email)


  }


  heartDiseaseMedication(event) {
    if (event.value == "Yes") {
      this.heartMedicationStatus = true
      // this.createForm()
    } else {

      this.heartMedicationStatus = false
    }
  }

  respiratoryMedication(event) {
    console.log("even when medication type selected", event);
    if (event.value == "Yes") {
      this.respiratoryMedicationStatus = true
      // this.createForm()
    } else {

      this.respiratoryMedicationStatus = false
    }
  }



  neurologicalDiseaseDetailsChange(event) {
    console.log("even when medication type selected", event);
    if (event.value == "Yes") {
      this.neurologicalDisease1Status = true
      // this.createForm()
    } else {

      this.neurologicalDisease1Status = false
    }

    // this.heartMedicationStatus = event.value
  }


  weakness1Change(event) {
    console.log("even when medication type selected", event);
    if (event.value == "Yes") {
      this.weakness1Status = true
      // this.createForm()
    } else {

      this.weakness1Status = false
    }
  }


  mentalHealth1Change(event) {
    console.log("even when medication type selected", event);
    if (event.value == "Yes") {
      this.mentalHealth1Status = true
      // this.createForm()
    } else {

      this.mentalHealth1Status = false
    }
  }


  musculoskeletal1Change(event) {
    console.log("even when medication type selected", event);
    if (event.value == "Yes") {
      this.musculoskeletal1Status = true
      // this.createForm()
    } else {

      this.musculoskeletal1Status = false
    }
  }



  sleepDisorder1Change(event) {
    console.log("even when medication type selected", event);
    if (event.value == "Yes") {
      this.sleepDisorder1Status = true
      // this.createForm()
    } else {

      this.sleepDisorder1Status = false
    }
  }


  endocrineDisorder1Change(event) {
    console.log("even when medication type selected", event);
    if (event.value == "Yes") {
      this.endocrineDisorder1Status = true
      // this.createForm()
    } else {

      this.endocrineDisorder1Status = false
    }
  }


  behaviouralDisorder1Change(event) {
    console.log("even when medication type selected", event);
    if (event.value == "Yes") {
      this.behaviouralDisorder1Status = true
      // this.createForm()
    } else {

      this.behaviouralDisorder1Status = false
    }
  }



  hearingDisorder1Change(event) {
    console.log("even when medication type selected", event);
    if (event.value == "Yes") {
      this.hearingDisorder1Status = true
      // this.createForm()
    } else {

      this.hearingDisorder1Status = false
    }
  }



  speech1Change(event) {
    console.log("even when medication type selected", event);
    if (event.value == "Yes") {
      this.speech1ChangeStatus = true
      // this.createForm()
    } else {

      this.speech1ChangeStatus = false
    }
  }



  bowelDisorder1Change(event) {
    console.log("even when medication type selected", event);
    if (event.value == "Yes") {
      this.bowelDisorder1Status = true
      // this.createForm()
    } else {

      this.bowelDisorder1Status = false
    }
  }



  kidneyDisorder1Change(event) {
    console.log("even when medication type selected", event);
    if (event.value == "Yes") {
      this.kidneyDisorder1Status = true
      // this.createForm()
    } else {

      this.kidneyDisorder1Status = false
    }
  }


  liverDisorder1Change(event) {
    console.log("even when medication type selected", event);
    if (event.value == "Yes") {
      this.liverDisorder1Status = true
      // this.createForm()
    } else {

      this.liverDisorder1Status = false
    }
  }


  getCommonDetails() {
    const user = this.candidateList.find((x) => x.userId === this.userId)
    console.log("SINGLE USER DETAILS", user)
    let obj = {
      accidentId: this.jobId,
      userId: user.userModelId,
      testedIndividualId: this.userId
    }
    console.log("THIS IS THE FINAL LIST", this.candidateList)
    this._userDocumentService.getBreathAlcoholDocument(obj).subscribe((response) => {
      this.otherFormDetails = response.common
      console.log("THIS IS THE COMMON DETAILS", this.otherFormDetails)
      console.log("CURRENT FORM DATA", this.personalDetailsForm.value, this.selectedDay, this.selectedMonth, this.selectedYear)
      if (this.personalDetailsForm && this.personalDetailsForm.value) {
        if (this.otherFormDetails && this.otherFormDetails.dob !== '' && (this.selectedDay === undefined && this.selectedMonth === undefined && this.selectedYear === undefined)) {
          const dobDate = moment(this.otherFormDetails.dob).format('DD/MM/YYYY').split('/')
          this.selectedDay = Number(dobDate[0])
          this.selectedMonth = Number(dobDate[1])
          this.selectedYear = Number(dobDate[2])
        }
        if (this.otherFormDetails && this.otherFormDetails.confirmId && this.otherFormDetails.confirmId.length) {
          this.otherFormDetails.confirmId = this.otherFormDetails.confirmId.map((x) => {
            console.log("SINGLE ITEM", x)
            if (x === 'sentinelCard') x = 'Sentinel Card'
            if (x === 'drivingLicence') x = 'Driving Licence'
            if (x === 'passport') x = 'Passport'
            if (x === 'companyID') x = 'Company ID'
            if (x === 'other') x = 'Other'
            return x
          })
          console.log("ID CONFIRM DATA", this.otherFormDetails.confirmId)
          this.personalDetailsForm.patchValue({ idConfirmed: this.otherFormDetails.confirmId })
        }
        this.personalDetailsForm.patchValue({ natInstNo: this.otherFormDetails.nationaInsuranceNumber })
        this.personalDetailsForm.patchValue({ sentinalNo: this.otherFormDetails.sentinelNumber })
        this.personalDetailsForm.updateValueAndValidity()
      }
    }, error => {
      console.log("ERROR WHILE GET USER FORM", error)
      // this.loading = false
    })
  }


}